import { useEffect, useState } from "react";

function Countdown() {
  // Set event date here
  const eventDate = new Date("2026-03-03 00:00:00").getTime();

  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = eventDate - now;

      if (distance <= 0) {
        clearInterval(interval);
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        return;
      }

      setTimeLeft({
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        ),
        minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((distance % (1000 * 60)) / 1000),
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [eventDate]);

  return (
    <section className="countdown-strip">
      <div id="countdown">
        <strong>ACTnet Event Starts In:</strong> <span>{timeLeft.days}</span>{" "}
        Days
        <span> {timeLeft.hours}</span> Hours
        <span> {timeLeft.minutes}</span> Minutes
        <span> {timeLeft.seconds}</span> Seconds
      </div>
    </section>
  );
}

export default Countdown;
